<template lang="pug">
div(class="xl12 l12 m12 s12 insety-16 border-bottom")
    div(class="insety-16")
        label(class="bold bond-title fg70") {{ $t('treasury_type') }}
    div(class="xl12 l12 m12 s12 flex-flex after-16")
        div(class="matdate cr-date")
            ib-dropdown(
                class="inset-8",
                name="treasuryselect",
                v-model="selected",
                :data="types",
                width="20ch"
            )
</template>

<script>
    import mxGb from '../mixin/mixin-global'
    export default {
        name: 'TreasuryType',

        mixins: [ mxGb ],

        data() {
            return {
                selected: '',
                types: [
                    { label: this.$t('all'), value: '' },
                    { label: this.$t('bill'), value: 'Bill' },
                    { label: this.$t('bond'), value: 'Bond' },
                    { label: this.$t('bond_strips_interest'), value: 'Bond STRIPS Interest' },
                    { label: this.$t('bond_strips_principal'), value: 'Bond STRIPS Principal' },
                    { label: this.$t('bond_tips'), value: 'Bond TIPS' },
                    { label: this.$t('bond_tips_strips_interest'), value: 'Bond TIPS STRIPS Interest' },
                    { label: this.$t('bond_tips_strips_principal'), value: 'Bond TIPS STRIPS Principal' },
                    { label: this.$t('note'), value: 'Note' },
                    { label: this.$t('note_strips_interest'), value: 'Note STRIPS Interest' },
                    { label: this.$t('note_strips_principal'), value: 'Note STRIPS Principal' },
                    { label: this.$t('note_tips'), value: 'Note TIPS' },
                    { label: this.$t('note_tips_strips_interest'), value: 'Note TIPS STRIPS Interest' },
                    { label: this.$t('note_tips_strips_principal'), value: 'Note TIPS STRIPS Principal' },
                ]
            }
        },

        methods: {
           getSelected(val) {
               this.selected = val;
               this.$emit('type', this.selected);
           },
           reset() {
               this.selected = '';
               this.$emit('type', this.selected);
           }
        },

        mounted() {
            this.$nextTick(() => {
                if (this.subFilters) {
                    this.selected = this.getFilterValue('bondAssetSubTypeStrBeginsWithOneOf') || '';
                }
                this.$emit('type', this.selected);
            });
        },

        watch: {
            selected: {
                handler(val) {
                    this.getSelected(val)
                }
            }
        }
    }
</script>